import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { RecentlyViewedModel, RecentlyViewedViewType } from "@NA/Services/ADIRecentlyViewedService";
import RecentlyViewedState from "@NA/Store/Data/ADIRecentlyViewedState";
import { Draft } from "immer";


const initialState: RecentlyViewedState = {
    isLoading: false,
    view: "Grid",
    recentlyViewedProducts: undefined,
    recentlyViewedInfosByLineId: undefined,
};

const reducer = {
    "Custom/LoadRecentlyViewedProducts": (draft: Draft<RecentlyViewedState>, action: { result: RecentlyViewedModel }) => {
        draft.isLoading = true;
    },
    "Custom/DispatchCompleteRecentlyViewedProduct": (
        draft: Draft<RecentlyViewedState>,
        action: { recentlyViewedProducts:{result: RecentlyViewedModel } },
    ) => {
        draft.isLoading = false;
        draft.recentlyViewedProducts = action.recentlyViewedProducts?.result;
    },
    "Custom/MyPurchaseHistory/SetView": (
        draft: Draft<RecentlyViewedState>,
        action: { parameter: { view: RecentlyViewedViewType } },
    ) => {
        draft.view = action.parameter.view;
        draft.isLoading = false;
    },
    "Custom/RecentlyViewedProduct/SetRealtimePricing": (
        draft: Draft<RecentlyViewedState>,
        action: { recentlyViewedInfosByLineId:{productInfosByLineId: SafeDictionary<ProductInfo> } },
    ) => {
        draft.recentlyViewedInfosByLineId = action.recentlyViewedInfosByLineId.productInfosByLineId;
        draft.isLoading = false;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);